import React        from 'react';
import SmallModal   from '../SmallModal/small_modal_container';
import ConfirmModal from '../ConfirmModal/ConfirmModal';

const EmailValidationModal = ({
  emailStatus,
  confirm,
  cancel,
  email,
  isEmailVerification,
}) => (
  <React.Fragment>
    { emailStatus === 'INVALID_EMAIL_ADDRESS' && (
      <SmallModal
        content={(
          <ConfirmModal
            title="Invalid Email Address"
            message="Please check your email address"
            confirm={confirm}
            confirmText="OK"
            hideCancel
          />
        )}
      />
    )}
    { emailStatus === 'UNKNOWN_EMAIL_ADDRESS' && (
      <SmallModal
        content={(
          <ConfirmModal
            message={`Are you sure this is the correct email address: ${email}`}
            confirm={confirm}
            confirmText={isEmailVerification ? 'Send Verification Email' : 'Confirm'}
            cancel={cancel}
            buttonStyle={{ minWidth: '200px' }}
          />
        )}
      />
    )}
  </React.Fragment>
);

export default EmailValidationModal;



// WEBPACK FOOTER //
// ./src/components/EmailValidationModal/EmailValidationModal.jsx